/**
 * Public content base this admin's Worker serves catalogs/packs from — copied verbatim from
 * `apps/admin-web/src/lib/contentBase.ts` (mirrors `apps/admin/ui/contentBase.ts`) so the Mantis
 * Invites grant picker agrees with both other admins on what a grant `ref` looks like
 * (`@equipped/core/content/grantRef.ts`, consumed via `grantTargets`). Empty when no backend is
 * configured.
 */
export function publicContentBaseUrl(backendUrl: string | null): string {
  return backendUrl ? `${backendUrl}/public` : "";
}

/**
 * The admin app's root published catalog — the master root index (docs/278) —
 * mirrors `apps/admin-web/src/lib/contentBase.ts`'s `ROOT_CATALOG_URL` 1:1.
 */
export function rootCatalogUrl(backendUrl: string | null): string {
  const publicBase = publicContentBaseUrl(backendUrl);
  return publicBase ? `${publicBase}/all-root-catalogs.json` : "";
}
